/**
 * KAN-1003: публичная страница /privacy (Политика конфиденциальности).
 */
import { LegalPageShell } from '@/components/legal/LegalPageShell';
import { LegalDocumentView } from '@/components/legal/LegalText';
import { PRIVACY_DOCUMENT } from '@/content/legal/privacy';

export function PrivacyPage() {
  return (
    <LegalPageShell documentTitle={PRIVACY_DOCUMENT.title}>
      <LegalDocumentView document={PRIVACY_DOCUMENT} />
    </LegalPageShell>
  );
}

export default PrivacyPage;
